var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.21967 5.21967C9.48594 4.9534 9.9026 4.9292 10.1962 5.14705L10.2803 5.21967L16.2803 11.2197C16.5466 11.4859 16.5708 11.9026 16.3529 12.1962L16.2803 12.2803L10.2803 18.2803C9.98744 18.5732 9.51256 18.5732 9.21967 18.2803C8.9534 18.0141 8.9292 17.5974 9.14705 17.3038L9.21967 17.2197L14.689 11.75L9.21967 6.28033C8.9534 6.01406 8.9292 5.5974 9.14705 5.30379L9.21967 5.21967Z","fill":"#313335"}));
}

ChevronRight.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
